export class VehicleBrand {
  public static readonly TOYOTA_STRING = 'TOYOTA';
  public static readonly LEXUS_STRING = 'LEXUS';

  public name = 'Toyota'
  private toyota = true;

  public static from(brandString: string): VehicleBrand {
    return new VehicleBrand(brandString);
  }

  constructor(
    public brandString: string
  ) {
    if (brandString && (brandString.length > 0) && brandString.toLowerCase().includes(VehicleBrand.LEXUS_STRING.toLowerCase())) {
      this.brandString = VehicleBrand.LEXUS_STRING;
      this.name = 'Lexus';
      this.toyota = false;
    } else {
      this.brandString = VehicleBrand.TOYOTA_STRING;
      this.name = 'Toyota';
      this.toyota = true;
    }
  }

  public static get TOYOTA() {
    return new VehicleBrand(VehicleBrand.TOYOTA_STRING);
  }

  public static get LEXUS() {
    return new VehicleBrand(VehicleBrand.LEXUS_STRING);
  }

  get nameForCountryBrand(): string {
    return this.name;
  }

  isToyota() {
    return this.toyota;
  }

  isLexus() {
    return !this.toyota;
  }
}
